var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatedTrackedCandidatesNaDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13543_58637)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13543_58637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.36795 8.37071L5.50038 8.37658C5.58819 8.38367 5.67531 8.39757 5.76101 8.41796L5.88923 8.45337L5.89092 8.45423L6.51426 8.65833L6.69645 8.71318C7.60945 8.97153 8.58034 8.95356 9.48502 8.65833L10.1084 8.45423L10.1101 8.45337L10.2383 8.41796C10.3672 8.38712 10.4992 8.37114 10.633 8.37071H10.8793C11.7097 8.3708 12.5056 8.70126 13.0927 9.28843C13.6798 9.87552 14.0103 10.6715 14.0104 11.5018V12.3579C14.0098 12.7226 13.8797 13.0754 13.6435 13.3532C13.4072 13.6311 13.0797 13.8162 12.7199 13.8753H12.719C9.59376 14.386 6.40553 14.386 3.28029 13.8753C2.53604 13.754 1.98975 13.1113 1.98975 12.357V11.5018C1.98982 10.6715 2.31969 9.87552 2.90663 9.28843C3.49382 8.70126 4.29039 8.37071 5.1208 8.37071H5.36795ZM7.99965 1.73828C9.48009 1.73828 10.6803 2.93844 10.6803 4.41891C10.6803 5.89938 9.48009 7.09954 7.99965 7.09954C6.51934 7.09935 5.31903 5.89927 5.31903 4.41891C5.31903 2.93856 6.51934 1.73847 7.99965 1.73828Z",
    stroke: "#838383"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13543_58637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13543_58637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedTrackedCandidatesNaDark);
export default __webpack_public_path__ + "static/media/Created-Tracked-Candidates-NA-Dark.51f778096d879b5a7dc661460df4135a.svg";
export { ForwardRef as ReactComponent };